import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { listDocumentTypes, SchemaQueryKeys, type DocumentTypeResponse } from '../api';

/** Lists every document type (latest published version per slug) of the tenant. */
export function useDocumentTypes(): UseQueryResult<DocumentTypeResponse[]> {
  return useQuery({
    queryKey: SchemaQueryKeys.list(),
    queryFn: ({ signal }) => listDocumentTypes(signal),
  });
}
